var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"week-navigator"},[_c('img',{attrs:{"src":_vm.ChevronRight},on:{"click":_vm.clickPrev}}),_c('span',[_vm._v(_vm._s(_vm.currentDate))]),_c('img',{attrs:{"src":_vm.ChevronLeft},on:{"click":_vm.clickNext}})])
}
var staticRenderFns = []

export { render, staticRenderFns }